import { useField } from 'react-final-form';
import { Get, Paths } from 'type-fest';
import { useMemo } from 'react';

import {
  EngagementChannelConfigFormValues,
  EngagementChannel,
} from './engagement-channel-config.schema';

type FormPaths = Paths<EngagementChannelConfigFormValues>;

const smsPath = 'smsConfig.isEnabled' satisfies FormPaths;
const pushPath = 'pushNotificationConfig.isEnabled' satisfies FormPaths;

export const useEnabledEngagementChannels = () => {
  const {
    input: { value: isSmsEnabled },
  } = useField<Get<EngagementChannelConfigFormValues, typeof smsPath>>(smsPath, {
    subscription: { value: true },
  });

  const {
    input: { value: isPushEnabled },
  } = useField<Get<EngagementChannelConfigFormValues, typeof pushPath>>(pushPath, {
    subscription: { value: true },
  });

  const enabledChannels: EngagementChannel[] = useMemo(() => {
    const channels: EngagementChannel[] = [];

    if (isSmsEnabled) {
      channels.push('sms');
    }

    if (isPushEnabled) {
      channels.push('push');
    }

    return channels;
  }, [isSmsEnabled, isPushEnabled]);

  return enabledChannels;
};
